import { useState, useEffect, useContext } from "react";
import highcharts3d from "highcharts/highcharts-3d.src";
import useScreenSize from "../useScreenSize";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

highcharts3d(Highcharts);

/**
  * 
  * @param {{series :
      {
        type: string,
        name: string,
        data: [],
      },
    }[]} series 
  * @returns 
  */

const colors = Highcharts.getOptions().colors,
  categories = ["Pepsodent", "Close up", "Geisha", "OMO", "SO KLIN"],
  data = [
    {
      y: 61.04,
      color: colors[2],
    },
    {
      y: 9.47,
      color: colors[3],
    },
    {
      y: 9.32,
      color: colors[5],
    },
    {
      y: 8.15,
      color: colors[1],
    },
    {
      y: 11.02,
      color: colors[6],
    },
  ],
  browserData = data.map((item, index) => ({
    name: categories[index],
    y: item.y,
    color: item.color,
  }));

const Donut = ({ series }) => {
  const options = {
    chart: {
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
    },
    title: {
      text: "",
      // align: "center",
    },

    plotOptions: {
      pie: {
        shadow: false,
        center: ["50%", "50%"],
        innerSize: "40%",
        depth: 35,
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
        },
        showInLegend: true,
      },
      // column: {
      //   pointPadding: 0,
      //   borderWidth: 0,
      // },
    },
    legend: {
      // align: "right",
      // verticalAlign: "middle",
      // layout: "vertical",
      // itemMarginTop: 10,
      // itemMarginBottom: 10,
      // labelFormatter: function () {
      //   return `${this.name}: ${this.y}%`;
      // },
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      // pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      formatter: function () {
        return this.point.name + "<br />" + "Total:  " + this.y;
      },
    },
    xAxis: {
      // categories: categories,
      crosshair: true,
      type: "category",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    series: [
      {
        name: "Total",
        data: series || [],

        colorByPoint: true,
      },
    ],
  };

  return (
    <div className="">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        updateArgs={[true, true, true]}
      />
    </div>
  );
};

export default Donut;
